import { UserInfo } from "@/services/login-service/entities/UserLoginEntity";
import { Recurring, type CalendarEvent } from "./calendar";
import { isEqual } from "date-fns";
import { showAsMapping } from "@/utils/calendarUtils";
import i18next from "i18next";

export class AttendeeReservation {
  id!: number;
  name!: string;
  address!: string;
  type!: string;
  reservationId!: string;

  constructor(data: Partial<AttendeeReservation>) {
    Object.assign(this, data);
  }
}

export type ReservationResponse = DtoReservation[];

export type ReservationVersionResponse = ReservationVersionResponseDto[];
export class ReservationVersionResponseDto {
  userId!: string;
  version!: string;
  readAccessLevel!: string;
  constructor(data: Partial<ReservationVersionResponse>) {
    Object.assign(this, data);
  }
}
export class SSEEventsConnectionResponse {
  connectionId!: string;
  constructor(data: Partial<SSEEventsConnectionResponse>) {
    Object.assign(this, data);
  }
}

export class DtoReservation {
  calendarId!: string;
  version!: string;
  readAccessLevel!: string;
  reservations!: Reservation[];
  constructor(data: Partial<DtoReservation>) {
    Object.assign(this, data);
  }
}

export class Reservation {
  id!: string;
  calendarId!: string;
  eventId!: string;
  subject!: string;
  iCalUid!: string;
  startTime!: Date;
  endTime!: Date;
  timeZone!: string;
  showAs!: string;
  sensitivity!: string;
  importance!: string;
  categories!: string;
  organizerName!: string;
  organizerEmail!: string;
  createdDate!: Date;
  isAllDay!: boolean;
  lastUpdated!: Date;
  seriesMasterId!: string | null;
  eventType!: "SingleInstance" | "SeriesMaster" | "Occurrence" | "Exception" | "BackgroundEvent";
  attendees!: AttendeeReservation[];
  //batchId!: string;
  isDeleted!: boolean;
  dateModified!: Date;

  constructor(data: Partial<Reservation>) {
    Object.assign(this, data);
    if (typeof this.startTime === "string") this.startTime = new Date(this.startTime);
    if (typeof this.endTime === "string") this.endTime = new Date(this.endTime);
    if (typeof this.createdDate === "string") this.createdDate = new Date(this.createdDate);
    if (typeof this.lastUpdated === "string") this.lastUpdated = new Date(this.lastUpdated);
    if (typeof this.dateModified === "string") this.dateModified = new Date(this.dateModified);
    this.attendees = (data.attendees || []).map((a) => new AttendeeReservation(a));
  }
  toCalendarEvent(
    userIdMap?: Map<string, UserInfo>,
    readAccessLevel: string = "read"
  ): CalendarEvent {
    return {
      calendarId: this.calendarId,
      id: this.eventId,
      title:
        readAccessLevel && readAccessLevel === "freeBusyRead"
          ? i18next.t(
              `newEvent.showAs.${this.showAs.toLowerCase()}`,
              showAsMapping[this.showAs.toLowerCase()]
            )
          : this.subject,
      start: this.startTime,
      iCalUId: this.iCalUid,
      allDay: this.isAllDay,
      showAs: this.showAs as "Free" | "Tentative" | "Busy" | "WorkingElsewhere" | "Oof",
      end: this.endTime,
      location: "",
      organizer: this.organizerEmail,
      attendees: this.attendees.map((a) => a.address),
      eventType: this.eventType,
      createDate: this.createdDate,
      resource: userIdMap?.get(this.calendarId)?.name || "Calendar",
      categories: this.categories ? this.categories.split(",").map((c) => c.trim()) : [],
      priority: "medium",
      sensitivity: this.sensitivity as "Normal" | "Personal" | "Private" | "Confidential",
      recurring: new Recurring({
        seriesMasterId: this.seriesMasterId ? this.seriesMasterId : undefined
      }),
      readAccessLevel: readAccessLevel
    };
  }
}
